const modalClinician = (): JSX.Element => {
  return (
    <div>
      <p>
        This tool will quickly help you to identify risky substance use by patients. Resources are
        included at the end to help you provide patient feedback and follow-up.
      </p>
      <p>
        As this tool discusses sensitive information, you may wish to review guidelines on
        confidentiality when working with patients, along with any applicable state laws.
      </p>
    </div>
  );
};

export default modalClinician;
